// Icon Registry - Local icon imports to avoid CDN dependencies
// This file imports all icons used in the application from @iconify/icons-* packages
import { addIcon, addCollection } from '@iconify/react';

// Material Design Icons (mdi)
import mdiDomain from '@iconify/icons-mdi/domain';
import mdiAccountGroup from '@iconify/icons-mdi/account-group';
import mdiInformationOutline from '@iconify/icons-mdi/information-outline';
import mdiChevronLeft from '@iconify/icons-mdi/chevron-left';
import mdiMapMarker from '@iconify/icons-mdi/map-marker';
import mdiRefresh from '@iconify/icons-mdi/refresh';
import mdiCloudSync from '@iconify/icons-mdi/cloud-sync';
import mdiViewColumn from '@iconify/icons-mdi/view-column';
import mdiEmailMinus from '@iconify/icons-mdi/email-minus';
import mdiChevronDown from '@iconify/icons-mdi/chevron-down';
import mdiChevronUp from '@iconify/icons-mdi/chevron-up';
import mdiAccountCheckOutline from '@iconify/icons-mdi/account-check-outline';
import mdiOfficeBuildingOutline from '@iconify/icons-mdi/office-building-outline';
import mdiBriefcaseOutline from '@iconify/icons-mdi/briefcase-outline';
import mdiDownload from '@iconify/icons-mdi/download';
import mdiOpenInNew from '@iconify/icons-mdi/open-in-new';
import mdiMerge from '@iconify/icons-mdi/merge';
import mdiCertificate from '@iconify/icons-mdi/certificate';
import mdiDatabaseSync from '@iconify/icons-mdi/database-sync';
import mdiCalculatorVariant from '@iconify/icons-mdi/calculator-variant';
import mdiUsers from '@iconify/icons-mdi/users';
import mdiEvents from '@iconify/icons-mdi/events';
import mdiAutoFix from '@iconify/icons-mdi/auto-fix';
import mdiReportTree from '@iconify/icons-mdi/report-tree';
import mdiChevronRight from '@iconify/icons-mdi/chevron-right';
import mdiClose from '@iconify/icons-mdi/close';
import mdiLogout from '@iconify/icons-mdi/logout';
import mdiLogin from '@iconify/icons-mdi/login';
import mdiAccountSwitchOutline from '@iconify/icons-mdi/account-switch-outline';
import mdiLocation from '@iconify/icons-mdi/location';
import mdiPeople from '@iconify/icons-mdi/people';
import mdiBellNotification from '@iconify/icons-mdi/bell-notification';
import mdiPencil from '@iconify/icons-mdi/pencil';
import mdiAccountPlus from '@iconify/icons-mdi/account-plus';
import mdiCogOutline from '@iconify/icons-mdi/cog-outline';
import mdiShieldLockOutline from '@iconify/icons-mdi/shield-lock-outline';
import mdiKeyboardArrowUp from '@iconify/icons-mdi/keyboard-arrow-up';
import mdiKeyboardArrowDown from '@iconify/icons-mdi/keyboard-arrow-down';
import mdiAccountClock from '@iconify/icons-mdi/account-clock';
import mdiAlertCircle from '@iconify/icons-mdi/alert-circle';
import mdiAlert from '@iconify/icons-mdi/alert';
import mdiCheckCircle from '@iconify/icons-mdi/check-circle';
import mdiClockOutline from '@iconify/icons-mdi/clock-outline';
import mdiChartTimelineVariant from '@iconify/icons-mdi/chart-timeline-variant';
import mdiTrendingUp from '@iconify/icons-mdi/trending-up';
import mdiTrendingDown from '@iconify/icons-mdi/trending-down';
import mdiClockIn from '@iconify/icons-mdi/clock-in';
import mdiFileExcel from '@iconify/icons-mdi/file-excel';
import mdiFileImport from '@iconify/icons-mdi/file-import';
import mdiUpload from '@iconify/icons-mdi/upload';
import mdiFileDocument from '@iconify/icons-mdi/file-document';
import mdiImport from '@iconify/icons-mdi/import';
import mdiFileUploadOutline from '@iconify/icons-mdi/file-upload-outline';
import mdiPlay from '@iconify/icons-mdi/play';
import mdiContentCopy from '@iconify/icons-mdi/content-copy';
import mdiEye from '@iconify/icons-mdi/eye';
import mdiCloud from '@iconify/icons-mdi/cloud';
import mdiOfficeBuilding from '@iconify/icons-mdi/office-building';
import mdiCompare from '@iconify/icons-mdi/compare';
import mdiPlusCircle from '@iconify/icons-mdi/plus-circle';
import mdiCloudUpload from '@iconify/icons-mdi/cloud-upload';
import mdiDeleteOutline from '@iconify/icons-mdi/delete-outline';
import mdiSwapHorizontal from '@iconify/icons-mdi/swap-horizontal';
import mdiKeyPlus from '@iconify/icons-mdi/key-plus';
import mdiHeartPulse from '@iconify/icons-mdi/heart-pulse';
import mdiImageOffOutline from '@iconify/icons-mdi/image-off-outline';
import mdiFileDocumentOutline from '@iconify/icons-mdi/file-document-outline';
import mdiCloudSyncOutline from '@iconify/icons-mdi/cloud-sync-outline';
import mdiChartBoxOutline from '@iconify/icons-mdi/chart-box-outline';
import mdiSwapVertical from '@iconify/icons-mdi/swap-vertical';
import mdiApi from '@iconify/icons-mdi/api';
import mdiConnection from '@iconify/icons-mdi/connection';
import mdiSync from '@iconify/icons-mdi/sync';
import mdiMagnify from '@iconify/icons-mdi/magnify';
import mdiRestart from '@iconify/icons-mdi/restart';
import mdiClockTimeFourOutline from '@iconify/icons-mdi/clock-time-four-outline';
import mdiDatabaseImportOutline from '@iconify/icons-mdi/database-import-outline';
import mdiPause from '@iconify/icons-mdi/pause';
import mdiDatabaseArrowDown from '@iconify/icons-mdi/database-arrow-down';
import mdiPlayCircleOutline from '@iconify/icons-mdi/play-circle-outline';
import mdiArrowLeft from '@iconify/icons-mdi/arrow-left';
import mdiDatabaseRemove from '@iconify/icons-mdi/database-remove';
import mdiCalendarMultiselect from '@iconify/icons-mdi/calendar-multiselect';
import mdiEmailFastOutline from '@iconify/icons-mdi/email-fast-outline';
import mdiAccountPlusOutline from '@iconify/icons-mdi/account-plus-outline';
import mdiAccountQuestionOutline from '@iconify/icons-mdi/account-question-outline';
import mdiEmailSyncOutline from '@iconify/icons-mdi/email-sync-outline';
import mdiCursorDefaultClickOutline from '@iconify/icons-mdi/cursor-default-click-outline';
import mdiCheckDecagram from '@iconify/icons-mdi/check-decagram';
import mdiArrowRight from '@iconify/icons-mdi/arrow-right';
import mdiCloseCircleOutline from '@iconify/icons-mdi/close-circle-outline';
import mdiCheckCircleOutline from '@iconify/icons-mdi/check-circle-outline';
import mdiAccount from '@iconify/icons-mdi/account';
import mdiAccountGroupOutline from '@iconify/icons-mdi/account-group-outline';
import mdiAccountMultipleCheckOutline from '@iconify/icons-mdi/account-multiple-check-outline';
import mdiCircleOutline from '@iconify/icons-mdi/circle-outline';
// Access Level Builder icons
import mdiCancel from '@iconify/icons-mdi/cancel';
import mdiPlus from '@iconify/icons-mdi/plus';
import mdiGate from '@iconify/icons-mdi/gate';
import mdiTableNetwork from '@iconify/icons-mdi/table-network';
import mdiContentSave from '@iconify/icons-mdi/content-save';
import mdiCalendarMultiple from '@iconify/icons-mdi/calendar-multiple';
import mdiPencilOutline from '@iconify/icons-mdi/pencil-outline';
import mdiDelete from '@iconify/icons-mdi/delete';
import mdiClockCheck from '@iconify/icons-mdi/clock-check';
import mdiClockRemove from '@iconify/icons-mdi/clock-remove';
import mdiCalendarClock from '@iconify/icons-mdi/calendar-clock';
import mdiCalendarBlank from '@iconify/icons-mdi/calendar-blank';
import mdiClockEdit from '@iconify/icons-mdi/clock-edit';
import mdiCheck from '@iconify/icons-mdi/check';
import mdiDotsVertical from '@iconify/icons-mdi/dots-vertical';
import mdiClockTimeTwelve from '@iconify/icons-mdi/clock-time-twelve';
import mdiCalendarWeek from '@iconify/icons-mdi/calendar-week';
import mdiBriefcaseClock from '@iconify/icons-mdi/briefcase-clock';
import mdiCalendarEdit from '@iconify/icons-mdi/calendar-edit';
import mdiCodeJson from '@iconify/icons-mdi/code-json';
import mdiCodeTags from '@iconify/icons-mdi/code-tags';

// Solar Icons
import solarBellBingBoldDuotone from '@iconify/icons-solar/bell-bing-bold-duotone';
import solarEyeBold from '@iconify/icons-solar/eye-bold';
import solarEyeClosedBold from '@iconify/icons-solar/eye-closed-bold';
import solarDisketteBold from '@iconify/icons-solar/diskette-bold';
import solarAltArrowDownLineDuotone from '@iconify/icons-solar/alt-arrow-down-line-duotone';
import solarSettingsBold from '@iconify/icons-solar/settings-bold';
import solarRefreshBold from '@iconify/icons-solar/refresh-bold';
import solarUsersGroupTwoRoundedBold from '@iconify/icons-solar/users-group-two-rounded-bold';
import solarUsersGroupRoundedBold from '@iconify/icons-solar/users-group-rounded-bold';
import solarClockCircleBold from '@iconify/icons-solar/clock-circle-bold';
import solarTrashBinTrashBold from '@iconify/icons-solar/trash-bin-trash-bold';
import solarUserBold from '@iconify/icons-solar/user-bold';
import solarDangerTriangleBold from '@iconify/icons-solar/danger-triangle-bold';
import solarHomeAddOutline from '@iconify/icons-solar/home-add-outline';
import solarScannerBold from '@iconify/icons-solar/scanner-bold';
import solarMonitorBold from '@iconify/icons-solar/monitor-bold';
import solarKeyMinimalisticSquare3Bold from '@iconify/icons-solar/key-minimalistic-square-3-bold';
import solarAltArrowUpBold from '@iconify/icons-solar/alt-arrow-up-bold';
import solarAltArrowDownBold from '@iconify/icons-solar/alt-arrow-down-bold';
import solarBoltBold from '@iconify/icons-solar/bolt-bold';
import solarAddCircleBold from '@iconify/icons-solar/add-circle-bold';
import solarPenBold from '@iconify/icons-solar/pen-bold';
import solarShieldCheckBold from '@iconify/icons-solar/shield-check-bold';
import solarGalleryBold from '@iconify/icons-solar/gallery-bold';
import solarGalleryMinimalisticBold from '@iconify/icons-solar/gallery-minimalistic-bold';
import solarUploadBold from '@iconify/icons-solar/upload-bold';
import solarGalleryAddBold from '@iconify/icons-solar/gallery-add-bold';
import solarCheckCircleBold from '@iconify/icons-solar/check-circle-bold';

// Eva Icons
import evaPlusFill from '@iconify/icons-eva/plus-fill';
import evaSearchFill from '@iconify/icons-eva/search-fill';
import evaTrash2Outline from '@iconify/icons-eva/trash-2-outline';
import evaDoneAllFill from '@iconify/icons-eva/done-all-fill';
import evaClockOutline from '@iconify/icons-eva/clock-outline';
import evaMenu2Fill from '@iconify/icons-eva/menu-2-fill';

// Material Symbols
import materialSymbolsDownload from '@iconify/icons-material-symbols/download';
import materialSymbolsRefresh from '@iconify/icons-material-symbols/refresh';
import materialSymbolsCircle from '@iconify/icons-material-symbols/circle';
import materialSymbolsCheck from '@iconify/icons-material-symbols/check';
import materialSymbolsMarkEmailReadRounded from '@iconify/icons-material-symbols/mark-email-read-rounded';
import materialSymbolsSave from '@iconify/icons-material-symbols/save';
import materialSymbolsWarningOutline from '@iconify/icons-material-symbols/warning-outline';
import materialSymbolsPendingActions from '@iconify/icons-material-symbols/pending-actions';
import materialSymbolsMenu from '@iconify/icons-material-symbols/menu';
import materialSymbolsNotifications from '@iconify/icons-material-symbols/notifications';
import materialSymbolsSettings from '@iconify/icons-material-symbols/settings';
import materialSymbolsSettingsOutline from '@iconify/icons-material-symbols/settings-outline';
import materialSymbolsAccountCircle from '@iconify/icons-material-symbols/account-circle';
import materialSymbolsAdd from '@iconify/icons-material-symbols/add';
import materialSymbolsDoorFront from '@iconify/icons-material-symbols/door-front';
import materialSymbolsDoorOpen from '@iconify/icons-material-symbols/door-open';
import materialSymbolsMeetingRoom from '@iconify/icons-material-symbols/meeting-room';
import materialSymbolsUpload from '@iconify/icons-material-symbols/upload';
import materialSymbolsError from '@iconify/icons-material-symbols/error';
import materialSymbolsArrowUpward from '@iconify/icons-material-symbols/arrow-upward';
import materialSymbolsArrowDownward from '@iconify/icons-material-symbols/arrow-downward';
import materialSymbolsDashboard from '@iconify/icons-material-symbols/dashboard';
import materialSymbolsUploadFile from '@iconify/icons-material-symbols/upload-file';
import materialSymbolsDelete from '@iconify/icons-material-symbols/delete';
import materialSymbolsDeleteOutline from '@iconify/icons-material-symbols/delete-outline';
import materialSymbolsSwapVert from '@iconify/icons-material-symbols/swap-vert';
import materialSymbolsPictureAsPdfOutline from '@iconify/icons-material-symbols/picture-as-pdf-outline';

// Octicon Icons
import octiconAlert24 from '@iconify/icons-octicon/alert-24';

// Remix Icon (ri)
import riSearchLine from '@iconify/icons-ri/search-line';
import riMore2Fill from '@iconify/icons-ri/more-2-fill';

// WPF Icons
import wpfConnected from '@iconify/icons-wpf/connected';
import wpfDisconnected from '@iconify/icons-wpf/disconnected';

// Font Awesome 6 Solid
import fa6SolidUser from '@iconify/icons-fa6-solid/user';
import fa6SolidSitemap from '@iconify/icons-fa6-solid/sitemap';
import fa6SolidXmark from '@iconify/icons-fa6-solid/xmark';
import fa6SolidCameraRotate from '@iconify/icons-fa6-solid/camera-rotate';
import fa6SolidCamera from '@iconify/icons-fa6-solid/camera';
import fa6SolidQuestion from '@iconify/icons-fa6-solid/question';

// Icomoon Free
import icomoonFreeUserCheck from '@iconify/icons-icomoon-free/user-check';
import icomoonFreeUserMinus from '@iconify/icons-icomoon-free/user-minus';

// Game Icons
import gameIconsTimeTrap from '@iconify/icons-game-icons/time-trap';

// TDesign Icons
import tdesignUserTime from '@iconify/icons-tdesign/user-time';

// Fluent Icons
import fluentBuildingPeople20Filled from '@iconify/icons-fluent/building-people-20-filled';

// Iconoir Icons
import iconoirReports from '@iconify/icons-iconoir/reports';

// FE Icons
import feArrowUp from '@iconify/icons-fe/arrow-up';
import feArrowRight from '@iconify/icons-fe/arrow-right';

// SVG Spinners
import svgSpinnersPulseRings2 from '@iconify/icons-svg-spinners/pulse-rings-2';

// Heroicons Solid
import heroiconsSolidUsers from '@iconify/icons-heroicons-solid/users';

// Tabler Icons
import tablerRadioactive from '@iconify/icons-tabler/radioactive';
import tablerRadioactiveOff from '@iconify/icons-tabler/radioactive-off';

// Icon registry object mapping string identifiers to icon objects
const iconRegistry = {
  // MDI icons
  'mdi:domain': mdiDomain,
  'mdi:account-group': mdiAccountGroup,
  'mdi:information-outline': mdiInformationOutline,
  'mdi:chevron-left': mdiChevronLeft,
  'mdi:map-marker': mdiMapMarker,
  'mdi:refresh': mdiRefresh,
  'mdi:cloud-sync': mdiCloudSync,
  'mdi:view-column': mdiViewColumn,
  'mdi:email-minus': mdiEmailMinus,
  'mdi:chevron-down': mdiChevronDown,
  'mdi:chevron-up': mdiChevronUp,
  'mdi:account-check-outline': mdiAccountCheckOutline,
  'mdi:office-building-outline': mdiOfficeBuildingOutline,
  'mdi:briefcase-outline': mdiBriefcaseOutline,
  'mdi:download': mdiDownload,
  'mdi:open-in-new': mdiOpenInNew,
  'mdi:merge': mdiMerge,
  'mdi:certificate': mdiCertificate,
  'mdi:database-sync': mdiDatabaseSync,
  'mdi:calculator-variant': mdiCalculatorVariant,
  'mdi:users': mdiUsers,
  'mdi:events': mdiEvents,
  'mdi:auto-fix': mdiAutoFix,
  'mdi:report-tree': mdiReportTree,
  'mdi:chevron-right': mdiChevronRight,
  'mdi:close': mdiClose,
  'mdi:logout': mdiLogout,
  'mdi:login': mdiLogin,
  'mdi:account-switch-outline': mdiAccountSwitchOutline,
  'mdi:location': mdiLocation,
  'mdi:people': mdiPeople,
  'mdi:bell-notification': mdiBellNotification,
  'mdi:pencil': mdiPencil,
  'mdi:account-plus': mdiAccountPlus,
  'mdi:cog-outline': mdiCogOutline,
  'mdi:shield-lock-outline': mdiShieldLockOutline,
  'mdi:keyboard-arrow-up': mdiKeyboardArrowUp,
  'mdi:keyboard-arrow-down': mdiKeyboardArrowDown,
  'mdi:account-clock': mdiAccountClock,
  'mdi:alert-circle': mdiAlertCircle,
  'mdi:alert': mdiAlert,
  'mdi:check-circle': mdiCheckCircle,
  'mdi:clock-outline': mdiClockOutline,
  'mdi:chart-timeline-variant': mdiChartTimelineVariant,
  'mdi:trending-up': mdiTrendingUp,
  'mdi:trending-down': mdiTrendingDown,
  'mdi:clock-in': mdiClockIn,
  'mdi:file-excel': mdiFileExcel,
  'mdi:file-import': mdiFileImport,
  'mdi:upload': mdiUpload,
  'mdi:file-document': mdiFileDocument,
  'mdi:import': mdiImport,
  'mdi:file-upload-outline': mdiFileUploadOutline,
  'mdi:play': mdiPlay,
  'mdi:content-copy': mdiContentCopy,
  'mdi:eye': mdiEye,
  'mdi:cloud': mdiCloud,
  'mdi:office-building': mdiOfficeBuilding,
  'mdi:compare': mdiCompare,
  'mdi:plus-circle': mdiPlusCircle,
  'mdi:cloud-upload': mdiCloudUpload,
  'mdi:delete-outline': mdiDeleteOutline,
  'mdi:swap-horizontal': mdiSwapHorizontal,
  'mdi:key-plus': mdiKeyPlus,
  'mdi:heart-pulse': mdiHeartPulse,
  'mdi:image-off-outline': mdiImageOffOutline,
  'mdi:file-document-outline': mdiFileDocumentOutline,
  'mdi:cloud-sync-outline': mdiCloudSyncOutline,
  'mdi:chart-box-outline': mdiChartBoxOutline,
  'mdi:swap-vertical': mdiSwapVertical,
  'mdi:api': mdiApi,
  'mdi:connection': mdiConnection,
  'mdi:sync': mdiSync,
  'mdi:magnify': mdiMagnify,
  'mdi:restart': mdiRestart,
  'mdi:clock-time-four-outline': mdiClockTimeFourOutline,
  'mdi:database-import-outline': mdiDatabaseImportOutline,
  'mdi:pause': mdiPause,
  'mdi:database-arrow-down': mdiDatabaseArrowDown,
  'mdi:play-circle-outline': mdiPlayCircleOutline,
  'mdi:arrow-left': mdiArrowLeft,
  'mdi:database-remove': mdiDatabaseRemove,
  'mdi:calendar-multiselect': mdiCalendarMultiselect,
  'mdi:email-fast-outline': mdiEmailFastOutline,
  'mdi:account-plus-outline': mdiAccountPlusOutline,
  'mdi:account-question-outline': mdiAccountQuestionOutline,
  'mdi:email-sync-outline': mdiEmailSyncOutline,
  'mdi:cursor-default-click-outline': mdiCursorDefaultClickOutline,
  'mdi:check-decagram': mdiCheckDecagram,
  'mdi:arrow-right': mdiArrowRight,
  'mdi:close-circle-outline': mdiCloseCircleOutline,
  'mdi:check-circle-outline': mdiCheckCircleOutline,
  'mdi:account': mdiAccount,
  'mdi:account-group-outline': mdiAccountGroupOutline,
  'mdi:account-multiple-check-outline': mdiAccountMultipleCheckOutline,
  'mdi:cancel': mdiCancel,
  'mdi:plus': mdiPlus,
  'mdi:gate': mdiGate,
  'mdi:table-network': mdiTableNetwork,
  'mdi:content-save': mdiContentSave,
  'mdi:calendar-multiple': mdiCalendarMultiple,
  'mdi:pencil-outline': mdiPencilOutline,
  'mdi:delete': mdiDelete,
  'mdi:clock-check': mdiClockCheck,
  'mdi:clock-remove': mdiClockRemove,
  'mdi:calendar-clock': mdiCalendarClock,
  'mdi:calendar-blank': mdiCalendarBlank,
  'mdi:clock-edit': mdiClockEdit,
  'mdi:check': mdiCheck,
  'mdi:dots-vertical': mdiDotsVertical,
  'mdi:clock-time-twelve': mdiClockTimeTwelve,
  'mdi:calendar-week': mdiCalendarWeek,
  'mdi:briefcase-clock': mdiBriefcaseClock,
  'mdi:calendar-edit': mdiCalendarEdit,
  'mdi:code-json': mdiCodeJson,
  'mdi:code-tags': mdiCodeTags,

  // Solar icons
  'solar:bell-bing-bold-duotone': solarBellBingBoldDuotone,
  'solar:eye-bold': solarEyeBold,
  'solar:eye-closed-bold': solarEyeClosedBold,
  'solar:diskette-bold': solarDisketteBold,
  'solar:alt-arrow-down-line-duotone': solarAltArrowDownLineDuotone,
  'solar:settings-bold': solarSettingsBold,
  'solar:refresh-bold': solarRefreshBold,
  'solar:users-group-two-rounded-bold': solarUsersGroupTwoRoundedBold,
  'solar:users-group-rounded-bold': solarUsersGroupRoundedBold,
  'solar:clock-circle-bold': solarClockCircleBold,
  'solar:trash-bin-trash-bold': solarTrashBinTrashBold,
  'solar:user-bold': solarUserBold,
  'solar:danger-triangle-bold': solarDangerTriangleBold,
  'solar:home-add-outline': solarHomeAddOutline,
  'solar:scanner-bold': solarScannerBold,
  'solar:monitor-bold': solarMonitorBold,
  'solar:key-minimalistic-square-3-bold': solarKeyMinimalisticSquare3Bold,
  'solar:alt-arrow-up-bold': solarAltArrowUpBold,
  'solar:alt-arrow-down-bold': solarAltArrowDownBold,
  'solar:bolt-bold': solarBoltBold,
  'solar:add-circle-bold': solarAddCircleBold,
  'solar:pen-bold': solarPenBold,
  'solar:shield-check-bold': solarShieldCheckBold,
  'solar:gallery-bold': solarGalleryBold,
  'solar:gallery-minimalistic-bold': solarGalleryMinimalisticBold,
  'solar:upload-bold': solarUploadBold,
  'solar:gallery-add-bold': solarGalleryAddBold,
  'solar:check-circle-bold': solarCheckCircleBold,
  'solar:image-bold': solarGalleryBold,
  'solar:circle-bold': mdiCircleOutline,
  'solar:menu-dots': materialSymbolsMenu, // Fallback to material symbols

  // Eva icons
  'eva:plus-fill': evaPlusFill,
  'eva:search-fill': evaSearchFill,
  'eva:trash-2-outline': evaTrash2Outline,
  'eva:done-all-fill': evaDoneAllFill,
  'eva:clock-outline': evaClockOutline,
  'eva:menu-2-fill': evaMenu2Fill,

  // Material Symbols
  'material-symbols:account-circle': materialSymbolsAccountCircle,
  'material-symbols:download': materialSymbolsDownload,
  'material-symbols:refresh': materialSymbolsRefresh,
  'material-symbols:circle': materialSymbolsCircle,
  'material-symbols:check': materialSymbolsCheck,
  'material-symbols:mark-email-read-rounded': materialSymbolsMarkEmailReadRounded,
  'material-symbols:save': materialSymbolsSave,
  'material-symbols:file-save': materialSymbolsSave, // Alias
  'material-symbols:warning-outline': materialSymbolsWarningOutline,
  'material-symbols:pending-actions': materialSymbolsPendingActions,
  'material-symbols:menu': materialSymbolsMenu,
  'material-symbols:notifications': materialSymbolsNotifications,
  'material-symbols:settings': materialSymbolsSettings,
  'material-symbols:settings-outline': materialSymbolsSettingsOutline,
  'material-symbols:add': materialSymbolsAdd,
  'material-symbols:door-front': materialSymbolsDoorFront,
  'material-symbols:door-open': materialSymbolsDoorOpen,
  'material-symbols:meeting-room': materialSymbolsMeetingRoom,
  'material-symbols:upload': materialSymbolsUpload,
  'material-symbols:error': materialSymbolsError,
  'material-symbols:arrow-upward': materialSymbolsArrowUpward,
  'material-symbols:arrow-downward': materialSymbolsArrowDownward,
  'material-symbols:dashboard': materialSymbolsDashboard,
  'material-symbols:upload-file': materialSymbolsUploadFile,
  'material-symbols:delete': materialSymbolsDelete,
  'material-symbols:delete-outline': materialSymbolsDeleteOutline,
  'material-symbols:swap-vert': materialSymbolsSwapVert,
  'material-symbols:picture-as-pdf-outline': materialSymbolsPictureAsPdfOutline,

  // Octicon
  'octicon:alert-24': octiconAlert24,

  // Remix Icon
  'ri:search-line': riSearchLine,
  'ri:more-2-fill': riMore2Fill,

  // WPF
  'wpf:connected': wpfConnected,
  'wpf:disconnected': wpfDisconnected,

  // Font Awesome 6
  'fa6-solid:user': fa6SolidUser,
  'fa6-solid:sitemap': fa6SolidSitemap,
  'fa6-solid:close': fa6SolidXmark, // Using xmark as close
  'fa6-solid:xmark': fa6SolidXmark,
  'fa6-solid:camera-rotate': fa6SolidCameraRotate,
  'fa6-solid:camera': fa6SolidCamera,
  'fa6-solid:question': fa6SolidQuestion,
  'fa-solid:question': fa6SolidQuestion, // Alias for fa6-solid

  // Icomoon Free
  'icomoon-free:user-check': icomoonFreeUserCheck,
  'icomoon-free:user-minus': icomoonFreeUserMinus,

  // Game Icons
  'game-icons:time-trap': gameIconsTimeTrap,

  // TDesign
  'tdesign:user-time': tdesignUserTime,

  // Fluent
  'fluent:building-people-20-filled': fluentBuildingPeople20Filled,

  // Iconoir
  'iconoir:reports-solid': iconoirReports,
  'iconoir:reports': iconoirReports,

  // FE Icons
  'fe:arrow-up': feArrowUp,
  'fe:arrow-right': feArrowRight,

  // SVG Spinners
  'svg-spinners:pulse-rings-2': svgSpinnersPulseRings2,

  // Heroicons Solid
  'heroicons-solid:users': heroiconsSolidUsers,

  // Tabler
  'tabler:radioactive': tablerRadioactive,
  'tabler:radioactive-off': tablerRadioactiveOff,

  // Fallback icons for packages not installed locally
  'oui:anomaly-detection': materialSymbolsWarningOutline,
  'oui:app-uptime': materialSymbolsSettings, // Using settings as fallback
  'mage:dashboard-fill': materialSymbolsDashboard,
  'hugeicons:logout-01': mdiLogout, // Using mdi logout as fallback
  'material-symbols-light:delete-outline': materialSymbolsDeleteOutline,
  'material-symbols-light:card-travel-outline': materialSymbolsSettings,
  'mingcute:settings-3-fill': materialSymbolsSettings,
  'flowbite:desktop-pc-outline': materialSymbolsSettings,
  'carbon:web-services-task-definition-version': materialSymbolsSettings,
  'pajamas:status-health': materialSymbolsCheck,
  'lets-icons:expand-down-light': mdiChevronDown,
  'uil:camera': fa6SolidCamera,
  'iconamoon:arrow-up-2-bold': materialSymbolsArrowUpward,
  'iconamoon:arrow-down-2-bold': materialSymbolsArrowDownward,
  'ic:sharp-error': materialSymbolsError,
  'ic:baseline-edit-location-alt': mdiMapMarker,
  'iconoir:stats-report': iconoirReports,
};

/**
 * Register all icons with Iconify's internal storage
 * This allows them to be used by string reference without CDN calls
 */
function registerAllIcons() {
  let registered = 0;
  Object.entries(iconRegistry).forEach(([name, iconData]) => {
    try {
      addIcon(name, iconData);
      registered++;
    } catch (error) {
      console.error(`Failed to register icon "${name}":`, error);
    }
  });
  console.log(`✅ Registered ${registered} icons locally`);
}

// Register all icons immediately when this module loads
registerAllIcons();

/**
 * Get an icon from the registry by its string identifier
 * @param {string} iconName - Icon identifier in format "collection:icon-name"
 * @returns {object|null} Icon object or null if not found
 */
export function getIcon(iconName) {
  return iconRegistry[iconName] || null;
}

/**
 * Check if an icon exists in the registry
 * @param {string} iconName - Icon identifier
 * @returns {boolean}
 */
export function hasIcon(iconName) {
  return iconName in iconRegistry;
}

export default iconRegistry;

